/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Form_Context_Length_DescriptionInputs */



/**
* | output |
* | --- |
* | "Maximum context window size in tokens." |
*
* @param {Private_Models_Form_Context_Length_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_form_context_length_description = /** @type {((inputs?: Private_Models_Form_Context_Length_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Form_Context_Length_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Maximale Kontextfenstergröße in Token.")
	return /** @type {LocalizedString} */ ("Maximum context window size in tokens.")
});